import React, { useCallback } from 'react';
import { debounce } from 'lodash';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { useSearchParams } from 'react-router-dom';

import styles from './filterDatePickerStyles.scss';

const FilterDatePicker: React.FC<{ text: string; paramName: string }> = ({ text, paramName }) => {
  const [searchParams, setSearchParams] = useSearchParams();

  const currentParamValue = searchParams.get(paramName);

  const debouncedSetParamValue = debounce((date: Date): void => {
    searchParams.set('page', '1');
    searchParams.set(paramName, moment(date).format('MM/DD/yyyy'));
    setSearchParams(searchParams);
  }, 500);

  const setParamValue = useCallback(debouncedSetParamValue, [debouncedSetParamValue]);

  const deleteParamValue = useCallback(() => {
    searchParams.set('page', '1');
    searchParams.delete(paramName);
    searchParams.delete('recommended');
    searchParams.delete('fpid');
    setSearchParams(searchParams);
  }, [paramName, searchParams, setSearchParams]);

  return (
    <div className={styles.container}>
      <label htmlFor={paramName}>{text}</label>
      <DatePicker
        autoComplete="off"
        dateFormat="MM/dd/yyyy"
        isClearable
        id={paramName}
        onChange={(date): void => (date ? setParamValue(date) : deleteParamValue())}
        placeholderText="mm/dd/yyyy"
        selected={currentParamValue ? new Date(currentParamValue) : null}
      />
    </div>
  );
};

export default FilterDatePicker;
